import React from 'react';
import {Card} from "react-bootstrap";
import AOS from 'aos';
import 'aos/dist/aos.css';

export const Tile = (props) => {
    const navigator_item_step_2 = require('./images/navigator_item_step_2.png');

    function setClickedItemID() {

        //in case of subitems
        if (typeof (props.setCurrentItem) === 'function') {
            props.setCurrentItem(parseInt(props.id));
        }
    }

    function componentDidMount() {
        //AOS.init();
    }

    let s = props.clicktValue;

    return (
        <div className={"col mb-30"}>
            <div
                id={props.id}
                onClick={setClickedItemID}
                className={"card h-100 w-100 " + ((parseInt(props.id) === props.exclusiveTile) ? "active" : "")}
            >
                <div className={"card-body mb-0 d-flex text-center justify-content-center align-items-center w-100"}>
                    <p dangerouslySetInnerHTML={{ __html: props.children }}></p>
                </div>
            </div>
        </div>
    );
}